import request from '@/utils/request'

// 新建会议
export function addAmTemplate(params) {
  return request({
    url: '/template/createMeeting',
    method: 'post',
    data: params
  })
}

// 新建任务
export function addtask(params) {
  return request({
    url: '/morningMeeting/createTask',
    method: 'post',
    data: params
  })
}

// 修改任务
export function editTask(id, params) {
  return request({
    url: '/morningMeeting/editTask/' + id,
    method: 'post',
    data: params
  })
}

// 查询早会任务 morningDetails
// export function getMorningTask(params) {
//   return request({
//     url: '/morningMeeting/searchTask',
//     method: 'get',
//     params: params
//   })
// }
// 任务已确认
export function taskConfirm(id) {
  return request({
    url: '/morningMeeting/taskConfirm/' + id,
    method: 'post'
  })
}

// 任务日志
export function getLog(id) {
  return request({
    url: '/task/logs/' + id,
    method: 'get'
  })
}

// 查询任务
export function searchTask(params) {
  return request({
    url: '/morningMeeting/searchTask',
    method: 'get',
    params: params
  })
}
// 查询与我相关的早晚会任务 - 与我相关的全部tab数据
export function searchAllTask(params) {
  return request({
    url: 'morningMeeting/meetingTask',
    method: 'get',
    params: params
  })
}

// 获取任务详情
export function getTask(id) {
  return request({
    url: '/morningMeeting/getTask/' + id,
    method: 'get'
  })
}

// 任务已执行
export function taskExecution(params, id) {
  return request({
    url: '/morningMeeting/taskExecution/' + id,
    method: 'post',
    data: params
  })
}

// 任务已执行 morningDetails
// export function getOtherTask(params) {
//   return request({
//     url: 'morningMeeting/searchTask',
//     method: 'post',
//     data: params
//   })
// }

// 保存会议纪要
export function meetingsummary(query) {
  return request({
    url: 'meeting/summary',
    method: 'post',
    data: query
  })
}

// 早晚会任务数量统计
export function meetingTaskCount(params) {
  return request({
    url: 'morningMeeting/taskCount',
    method: 'get',
    params: params
  })
}

// 根据部门id、工号、查询会议数据，查询自己、部门长或组员会议日程
export function getMeetingSchedule(params) {
  return request({
    url: '/meeting/searchAll',
    method: 'post',
    data: params
  })
}
